import { color } from "@/theme";

export const AntdTheme = {
  token: {
    // Seed Token
    colorPrimary: color.primary01,
    colorLink: color.primary01,
    borderRadius: 80,
    colorTextBase: color.black01,
    fontFamily: "'Gmarket-Sans', sans-serif",
    colorError: color.tertiary,
    // colorErrorBg: "#F6F6F6",
    // colorErrorBorder: "#F6F6F6",
    colorLinkHover: color.tertiary,
    paddingXXS: 10,
  },
  components: {},
};
